<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-12 pt-3">
        <div class="card card-bottom-radius-8" style="background-color: #f9f9f9;">
          <div class="card-block">
            <div class="form-group row">
              <div class="col-md-12 text-center pt-3">
                <h3>SOLICITAR AUTORIZAÇÃO PARA REEMBOLSO DE VIAGEM</h3>
              </div>
              </div>
            <div class="form-group row pt-3">
              <div class="col-md-4">
                <label for="cbxInsure"><small class="text-danger">*</small> Obra:</label>
                <div>
                  {{dataDetailsTerm.obra == null ? 'N/D' : dataDetailsTerm.obra.referencia}}
                </div>
              </div>
              <div class="col-md-4">
                <label for="txtInsured"><small class="text-danger">*</small> Responsável <small>(Coordernador obra)</small>:</label>
                <div>
                  {{dataDetailsTerm.responsavel == null ? 'N/D' : dataDetailsTerm.responsavel.nome}}
                </div>
              </div>
              <div class="col-md-4">
                <label for="cbxInsure"><small class="text-danger">*</small> Regional:</label>
                <div>
                  {{dataDetailsTerm.secaoRH == null ? 'N/D' : dataDetailsTerm.secaoRH.nome}}
                </div>
              </div>
            </div>
            <div class="form-group row pt-3">
              <div class="col-md-4">
                <label for="txtInsured"><small class="text-danger">*</small> Funcionário <small>(Que receber o crédito)</small>:</label>
                <div>
                  {{dataDetailsTerm.favorecido == null ? 'N/D' : dataDetailsTerm.favorecido.nome}}
                </div>
              </div>
              <div class="col-md-2">
                <label for="cbxInsure"> Funcionário (Função):</label>
               <div>
                  {{dataDetailsTerm.favorecido.cargo.nome}}
                </div>
              </div>
              <div class="col-md-2">
                <label><small class="text-danger">*</small> Valor:</label>
                <div>
                  {{'R$ ' + dataDetailsTerm.valorSolicitado}}
                </div>
              </div>
              <div class="col-md-4">
                <label><small class="text-danger">*</small> Motivo Viagem:</label>
                <div>
                  {{dataDetailsTerm.motivoViagem.nome}}
                </div>
              </div>
            </div>
             <div class="form-group row pt-3">
              <div class="col-md-2">
                <label><small class="text-danger">*</small> Início Viagem:</label>
                 <div>
                  {{dataDetailsTerm.dataViagemInicio}}
                </div>
              </div>
              <div class="col-md-2">
                <label><small class="text-danger">*</small> Fim Viagem:</label>
                 <div>
                  {{dataDetailsTerm.dataViagemFim}}
                </div>
              </div>
              <div class="col-md-4">
                <label><small class="text-danger">*</small> Pais / Estado / Cidade Origem:</label>
                <div>
                  {{'BRASIL' + ' - ' + dataDetailsTerm.cidadeOrigem.estado.nome + ' - ' + dataDetailsTerm.cidadeOrigem.nome}}
                </div>
              </div>
              <div class="col-md-4">
                <label><small class="text-danger">*</small> Pais / Estado / Cidade Destino:</label>
                 <div>
                  {{'BRASIL' + ' - ' + dataDetailsTerm.cidadeDestino.estado.nome + ' - ' + dataDetailsTerm.cidadeDestino.nome}}
                </div>
              </div>
            </div>
            </div>
            <div class="form-group row pt-4">
              <div class="col-md-12 text-center">
                <h4>TERMO DE AUTORIZAÇÃO PARA REEMBOLSO DE VIAGEM</h4>
              </div>
          </div>
          <div class="form-group row">
              <div class="col-md-12 pt-2 pb-2 text-justify">
                <div class="pt-4 pl-4 pb-4 pr-4" style="background-color: #ffffff; border: solid 1px #e1e1e1; border-radius: 5px; min-height: 150px; max-height: 300px;overflow: auto;">
                   Eu, <strong>{{dataDetailsTerm.favorecido == null ? 'N/D' : dataDetailsTerm.favorecido.nome}}</strong> com o código <strong>{{dataDetailsTerm.favorecido == null ? 'N/D' : dataDetailsTerm.favorecido.codigo}}</strong>, funcionário da empresa
                  <strong>Zopone Engenharia e Comércio Ltda</strong>, autorizo a descontar na folha de pagamento, a
                  quantia de <strong>{{'R$ ' + dataDetailsTerm.valorSolicitado}}</strong>, referente à despesa de viagem.
                </div>
              </div>
            </div>
            <div class="col-md-12 text-right pt-4 pb-4">
                <button class="btn btn-primary btn-sm" v-on:click="$emit('backAuth')">Voltar</button>
            </div>
            <div @click="dowloadPdf" class="button-pdf"><i class="fas fa-file-pdf"></i></div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import AcceptanceTermRepository from '@/shared/http/repositories/business/acceptanceterm.js'
export default {
  name: 'DeatailsTerm',
  props: ['dataDetailsTerm'],
  data () {
    return {
      objTerm: []
    }
  },
  mounted () {
    console.log(this.dataDetailsTerm)
  },
  methods: {
    dowloadPdf () {
      AcceptanceTermRepository.print(this.dataDetailsTerm)
        .then(Response => {
          let pdfWindow = window.open('Despesa-Diversos.pdf')
          let pdf = encodeURI(Response.data.data)
          pdfWindow.document.write(`
            <embed width="100%" height="100%" src="data:application/pdf;base64,${pdf}"></embed>
          `)
        })
        .catch(Error => console.log(Error))
    }
  }
}
</script>

<style>
.button-pdf{
  position: absolute;
  top: 10px;
  right: 10px;
  background: rgb(0, 110, 255);
  border-radius: 8px;
  padding: 15px;
  cursor: pointer;
  font-size: 20px;
  color: white;
}
.button-pdf:hover{
  background: rgb(0, 78, 180);
}

</style>



// WEBPACK FOOTER //
// src/views/private/finance/accountability/components/detailsterm/detailsterm.vue